import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-header-signup',
  templateUrl: './content-header-signup.component.html',
  styleUrls: ['./content-header-signup.component.scss']
})
export class ContentHeaderSignupComponent implements OnInit {


  @Input('icon') icon:any;
  @Input('img') img:any;
  @Input('title') title:any;
  @Input('desc') desc:any;
  @Input('hideBreadcrumb') hideBreadcrumb:boolean = false;
  @Input('hasBgImage') hasBgImage:boolean = false;
  @Input('class') class:any;
  constructor() { }

  ngOnInit() {
  }
}
